import { render } from "./내게_맞는_검진프로그램01.vue?vue&type=template&id=dc2e38f2"
import script from "./내게_맞는_검진프로그램01.vue?vue&type=script&lang=js"
export * from "./내게_맞는_검진프로그램01.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__